import { makeGamificationRequest } from '../utils/request'
import type { FastestShotLeaderboardData } from './fastestShot.types'
import { GAMIFICATION_ENDPOINTS } from '../utils/endpoints'

/**
 * Fetch fastest shot leaderboard data for a specific location
 */
export async function fetchFastestShotLeaderboards(
  location: string
): Promise<FastestShotLeaderboardData | null> {

  try {
    const res = await makeGamificationRequest(GAMIFICATION_ENDPOINTS.FASTEST_SHOT_LEADERBOARD, {
      method: 'GET',
      apiVersion: '1',
      queryParams: {
        location
      }
    },
  )
    if(res?.error){
      res.error?.message && console.error(res.error?.message)
      return null
    }
    return res?.data
  } catch (error) {
    console.error(error)
    return null
  }
}
